import { mergeClasses, Image } from '@fluentui/react-components';

import { CardTemplate } from 'src/utils/enums';
import { BaseCardLayoutProps } from 'src/ui-models/cardLayout';
import CardBackgroundContent from '../../atoms/card-background-content/CardBackgroundContent';
import { useCardHalfBackgroundLayoutStyles } from './CardHalfBackgroundLayout.styles';

interface CardHalfBackgroundLayoutProps extends BaseCardLayoutProps {
  image: string
  topLine?: string
  cardTemplate: CardTemplate
  icon?: React.ReactNode
}

const CardHalfBackgroundLayout: React.FC<CardHalfBackgroundLayoutProps> = ({ headline, image, body, cardTemplate, topLine, icon, className }) => {
  const styles = useCardHalfBackgroundLayoutStyles();

  const container = mergeClasses(
    styles.container,
    cardTemplate === CardTemplate.RIGHT_SIDE_IMAGE && styles.rightSide,
    className,
  );
  const imageClass = cardTemplate === CardTemplate.RIGHT_SIDE_IMAGE ? styles.rightSideImage : styles.image;

  const renderTopLine = (): React.ReactNode => {
    if (!topLine && !icon) {
      return null;
    }

    return (
      <div className={styles.topLine} data-testid="card-half-background-layout-top-line">
        {icon}
        {topLine && <span data-testid="card-half-background-layout-top-line-text" className={styles.topLineText}>{topLine}</span>}
      </div>
    );
  };

  const dataTestId = cardTemplate === CardTemplate.RIGHT_SIDE_IMAGE
    ? 'card-half-background-layout-right-side'
    : 'card-half-background-layout';

  return (
    <div className={container} data-testid={dataTestId}>
      <Image className={imageClass} src={image} role="presentation" />
      <section>
        {renderTopLine()}

        <CardBackgroundContent headline={headline} body={body} />
      </section>
    </div>
  );
};

export default CardHalfBackgroundLayout;
